<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.AddressStreet" :label="$t('servicesystem.common_objects.commonterms.street')"
          :rules="[requiredRule]" clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <QTextField v-model="editItem.AddressPostalCode"
          :label="$t('servicesystem.common_objects.commonterms.postal_code')" :rules="[requiredRule]" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="9">
        <QTextField v-model="editItem.AddressCity" :label="$t('servicesystem.common_objects.commonterms.city')"
          :rules="[requiredRule]" clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PartnerCompanyAddressEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: {
      type: Function,
      default: () => {},
    },
  },
  components: {},

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>